





import { defineComponent } from "@vue/composition-api";

export default defineComponent({
	setup(props, context){
		const logout = async () => {
			await context.root.$store.dispatch("logout");
			context.root.$router.push("login");
		}
		logout();
		return {};
	}
});

